import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import { jwtDecode } from "jwt-decode";

const GoogleAuthCallback = () => {
  const navigate = useNavigate();
  const { setUser, setIsLoggedIn } = useContext(AuthContext);

  useEffect(() => {
    const handleGoogleLogin = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");

      if (token) {
        try {
          localStorage.setItem("token", token);
          const decodedUser = jwtDecode(token);

          // Save user object into localStorage so dashboard & App.js can read session
          const userObj = {
            userId: decodedUser.id || decodedUser._id || decodedUser.userId,
            userName: decodedUser.userName || decodedUser.name || "Google User",
            email: decodedUser.email || "",
            role: decodedUser.role || "user",
          };

          localStorage.setItem("user", JSON.stringify(userObj));
          if (userObj.userId) localStorage.setItem("userId", userObj.userId);
          if (userObj.userName) localStorage.setItem("userName", userObj.userName);

          if (setUser) setUser(userObj);
          if (setIsLoggedIn) setIsLoggedIn(true);

          setTimeout(() => {
            if (userObj.role === "admin") {
              navigate("/AdminDashboard");
            } else {
              navigate("/UserDashBoard");
            }
          }, 300);
        } catch (error) {
          console.error("Invalid Google token:", error);
          navigate("/login");
        }
      } else {
        navigate("/login");
      }
    };

    handleGoogleLogin();
  }, [navigate, setUser, setIsLoggedIn]);

  return (
    <div className="min-h-screen bg-slate-950 flex flex-col items-center justify-center text-white font-sans">
      <div className="w-12 h-12 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin mb-4" />
      <h3 className="text-xl font-bold">Authenticating with Google...</h3>
      <p className="text-xs text-emerald-300/80 mt-1">Redirecting to your dashboard</p>
    </div>
  );
};

export default GoogleAuthCallback;
